/**
 * "Situação da frente" da ficha (#365): o chip de situação e os números que o explicam, em
 * `InfoItem`s. Tudo vem do servidor; o cartão só escreve.
 */
import React from 'react';
import { Box } from '@mui/material';
import { Flag as FlagIcon } from '@mui/icons-material';

import { InfoItem, SectionCard } from '../../../components/common/DetailView';
import type { WorkFrontDetail } from '../../../types/workFront';
import { formatIsoDate } from '../../fire-equipments/fireDates';
import FrenteSituacaoChip from './FrenteSituacaoChip';

const currentStageText = (front: WorkFrontDetail): string => {
  const { kind, name, plannedEnd } = front.currentStage;
  if (kind === 'NONE') return 'Sem etapas';
  if (kind === 'DONE') return 'Todas as etapas concluídas';
  const until = plannedEnd ? ` · até ${formatIsoDate(plannedEnd)}` : '';
  return `${kind === 'NEXT' ? 'Próxima: ' : ''}${name ?? '—'}${until}`;
};

export const FrontSituationCard: React.FC<{ front: WorkFrontDetail }> = ({ front }) => (
  <SectionCard title="Situação da frente" icon={<FlagIcon />}>
    <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' } }}>
      <InfoItem label="Situação" value={<FrenteSituacaoChip situation={front.situation} lateDays={front.lateDays} />} />
      <InfoItem label="Etapa atual" value={currentStageText(front)} />
      <InfoItem label="Trabalhadores ativos" value={String(front.activeWorkersCount)} />
      <InfoItem label="Riscos marcados" value={String(front.markedRisksCount)} />
      {front.closedAt && <InfoItem label="Encerrada em" value={formatIsoDate(front.closedAt)} />}
    </Box>
  </SectionCard>
);

export default FrontSituationCard;
